<template>
    <div class="row">
        <open-parcels class="half-height" />
        <enterprise-logo class="half-height" />
    </div>
    <parcels :parcels="contractData.parcelas" />
    <div class="button-container">
        <button @click="visible = true" type="button" class="btn custom-btn bg-segment-primary-color mt-4">Demonstrativo
            de Pagamento</button>
    </div>
    <financial-summary />
    <Dialog v-model:visible="visible" modal header="Demonstrativo de pagamento" :style="{ width: '25rem' }">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-2 mt-sm-0">
            <label>Ano demonstrativo <i v-if="loadingCities" class="fa fa-spinner fa-pulse fa-fw"></i></label>
            <select v-model="selectedYear" class="multisteps-form__select form-control">
                <option v-for="year in years" :key="year" :value="year">{{ year }}
                </option>

            </select>
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-4">
            <label>Enviar demonstrativo para: </label>
            <InputText class="w-100" v-model="user" disabled />
        </div>
        <div class="mt-4 d-flex justify-content-center">
            <button type="button" @click="statementPayment()"
                class="btn custom-btn bg-segment-primary-color text-center d-flex justify-content-center" :disabled="loadingButton">Confirmar <i
                    v-if="loadingButton" class="fa fa-spinner fa-pulse fa-fw"></i>
            </button>
        </div>
    </Dialog>
</template>

<script setup>

import OpenParcels from "./components/OpenParcels.vue"
import Parcels from "./components/Parcels.vue"
import EnterpriseLogo from '../Home/components/EnterpriseLogo.vue';
import FinancialSummary from "./components/FinancialSummary.vue"
import { useStore } from "vuex";
import { computed, ref, onMounted } from 'vue';
import Dialog from 'primevue/dialog';
import axios from "axios";
import InputText from 'primevue/inputtext';
import { showToast } from "@/assets/js/toast.js";

const store = useStore();
const contractData = computed(() => store.getters.getCurrentContract);
const user = store.getters.getCurrentUser ? store.getters.getCurrentUser.email : null;
const visible = ref(false);
const loadingButton = ref(false);
const years = ref([])
const selectedYear = ref()
const statementPayment = async () => {
    if (!selectedYear.value) {
        showToast('Selecione o ano demonstrativo', 'error');
        return
    }
    let data = {
        year: selectedYear.value
    }
    try {
        loadingButton.value = true
        const response = await axios.post(`/contract-ws/${contractData.value.contrato_id}/statement-amounts-paid`, data);
        console.log(response)
        showToast('Demonstrativo enviado com sucesso', 'success');
    } catch (error) {
        showToast('Não foi possível enviar, tente novamente', 'error');
    } finally {
        loadingButton.value = false
    }
}

const getYears = () => {
    let initial = new Date().getFullYear();
    let maxYear = parseInt(contractData.value.data_cadastro, 10);
    let arrayYears = [];

    if (isNaN(maxYear)) {
        console.error('Invalid maxYear value');
        return;
    }

    while (initial >= maxYear) {
        arrayYears.push(initial);
        initial = initial - 1;
    }
    years.value = arrayYears
}

onMounted(async () => {
    getYears();
});

</script>

<style>
.half-height {
    height: 50% !important;
}

.button-container {
    display: flex;
    justify-content: center;
}
</style>